"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const clsx_1 = __importDefault(require("clsx"));
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const DashboardKpiCard = ({ title, data, className, noDataInfo, tooltipContent, children, }) => (react_1.default.createElement("div", { className: (0, clsx_1.default)('dashboard-content-card', 'kpi-card', className) },
    react_1.default.createElement("div", { className: 'kpi-card-title' },
        title,
        " ",
        tooltipContent && react_1.default.createElement(CustomToolTip_1.default, { info: tooltipContent, type: '?', inverse: true })), noDataInfo !== null && noDataInfo !== void 0 ? noDataInfo : (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("div", { className: 'kpi-card-data' }, data))),
    children));
exports.default = DashboardKpiCard;
